import ComposedMinimizedMail from './ComposedMinimizedMail';

export default ComposedMinimizedMail


// WEBPACK FOOTER //
// /src/components/mailThread/mail/composedMinimizedMail/index.js